/* External */
import { all } from "redux-saga/effects";

/* Services */
import { backendService } from "../../../services";

/* Others */
import { ACTION_TYPES_BASE_NAME } from "./actions";
import { makeFetchSaga } from "../../../utils";

const fetchPlayerAssetSaga = makeFetchSaga(ACTION_TYPES_BASE_NAME, {
  func: backendService.content.getAssetById,
  getParams: (
    { assetId, isLive },
    {
      allStations: { data: stations },
      player: {
        content: { data: content }
      }
    }
  ) => {
    if (!isLive) return [content?.assetIDs?.[0]];

    const station = stations.find(({ id }) => id === assetId);

    return [station?.assetID];
  }
});

export default function* () {
  yield all([fetchPlayerAssetSaga]);
}
